import style from '@aytm/app/stats/page/question-views/sh/components/shelf/styles/ShelfChart.module.scss'

// Returns a cleanup fn — caller must invoke it on unmount.
export const waitForShelfImage = (shelfId, onLoaded) => {
  const intervalId = setInterval(() => {
    const img = window[`AYTM_shelfImage_${shelfId}`]
    if (!img?.src) return

    clearInterval(intervalId)
    onLoaded(img)
  }, 1000)

  return () => clearInterval(intervalId)
}

// Legacy contract:
//   - renderImage:   `.path` truthy → fresh <img src=url>; else → append the global node.
//   - renderHeatmap: unconditional second append of the global node (jQuery silently
//                    no-ops when the global is a plain object, so the effective net
//                    is "+1 only when the global is a real Node").
// `window.AYTM_shelfImage_X` may be either an <img> Image element or a plain JSON
// `preview.original` payload — guard `instanceof Node` mirrors jQuery's tolerance.
export const appendShelfImageInto = (heatmapEl, image) => {
  if (image.path) {
    const imageNode = document.createElement('img')
    imageNode.setAttribute('src', image.url)
    heatmapEl.appendChild(imageNode)
  } else if (image instanceof Node) {
    heatmapEl.appendChild(image)
  }

  if (image instanceof Node) {
    heatmapEl.appendChild(image)
  }
}

// Legacy also set `marginLeft: 102px` for `displayFridge`, but a CoffeeScript
// precedence bug (`if @model.get false`) made that branch unreachable —
// intentionally not ported.
export const applySvgHeatmapStyles = (heatmapEl, image) => {
  if (image.width <= 750) return
  const svgEl = heatmapEl.querySelector(`.${style['svg-heatmap']}`)
  if (!svgEl) return
  svgEl.style.left = '0'
}

export const applyImageScaleStyles = (heatmapEl, shelfId, fullscreenScale) => {
  if (fullscreenScale === 1) return
  const imgEl = heatmapEl.querySelector('img')
  if (!imgEl) return
  imgEl.style.transform = `scale(${fullscreenScale})`
  imgEl.style.marginLeft = `${window[`AYTM_shelfMargin_${shelfId}`]}px`
}
